// extracted by mini-css-extract-plugin
export default {"container":"lF-z","innerContainer":"mF-z","multipleLines":"nF-z","heading":"oF-z","content":"pF-z","linkColor":"qF-z"};